import {
  FontWeights,
  getFilterBarStyles as getBaseFilterBarStyles,
  useTheme
} from "@bps/fluent-ui";

import { FilterBarStyles } from "./FilterBar.types.ts";

export const useFilterBarStyles = (): FilterBarStyles => {
  const theme = useTheme();
  const { select } = getBaseFilterBarStyles({ theme });
  return {
    peoplePicker: {
      root: {
        selectors: {
          "& +.picker-icon": {
            color: theme.palette.neutralSecondaryAlt
          }
        }
      },
      "& .ms-BasePicker-text": {
        border: "none",
        background: theme.palette.neutralLighterAlt
      },
      "& .ms-Persona-primaryText": {
        fontWeight: FontWeights.semibold
      }
    },
    select
  };
};
